import { differenceInYears } from "date-fns";
export const getCartSupplyType = (state) => state.cartDetails.cartDetails?.cart?.supplyType;
export const getCartDetailsFetchStatus = (state) => state.cartDetails.fetchStatus;
export const getCartDetails = (state) => state.cartDetails.cartDetails;
export const getCartToken = (state) => state.cartDetails.cartDetails?.cart.cartToken;
const getFinalDepartureDate = (segments) => {
    if (!segments || segments.length === 0) {
        return undefined;
    }
    const lastSegment = segments[segments.length - 1];
    return lastSegment.departureTime;
};
const calculateAge = (refDate, birthDate) => {
    if (!birthDate || !refDate) {
        return -1;
    }
    const transformedRefDate = new Date(refDate);
    const transformedBirthDate = new Date(birthDate);
    if (isNaN(transformedRefDate.valueOf()) || isNaN(transformedBirthDate.valueOf())) {
        return -1;
    }
    return differenceInYears(transformedRefDate, transformedBirthDate);
};
const getPassengerAgeList = (cartDetails) => {
    const passengers = cartDetails?.passengers;
    const departureDate = getFinalDepartureDate(cartDetails?.cart.offer.segments);
    if (!passengers || passengers.length === 0) {
        return [-1];
    }
    return passengers.map((passenger) => calculateAge(departureDate, passenger.birthDate));
};
export const getCartPassengerMaxAge = (state) => {
    return Math.max(...getPassengerAgeList(state.cartDetails.cartDetails));
};
export const getCartPassengerMinAge = (state) => {
    return Math.min(...getPassengerAgeList(state.cartDetails.cartDetails));
};
